export const MAIN_NAV_LOCATION_KEY = 'mainNavLocation'
